import { render, staticRenderFns } from "./Coiccert.vue?vue&type=template&id=20750192&scoped=true&"
import script from "./Coiccert.vue?vue&type=script&lang=js&"
export * from "./Coiccert.vue?vue&type=script&lang=js&"
import style0 from "./Coiccert.vue?vue&type=style&index=0&id=20750192&scoped=true&lang=css&"
import style1 from "./Coiccert.vue?vue&type=style&index=1&id=20750192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20750192",
  null
  
)

export default component.exports